// Generated by scripts/syncExperienceRegistry.mjs. Do not edit.
export default {
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "https://timelining.app/schemas/experience-engine-registry-v1.json",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "schemaVersion",
    "registryVersion",
    "engine",
    "firestore",
    "processing",
    "conditionLanguage",
    "performance",
    "feedback",
    "celebrationCatalog",
    "gamification",
    "actions"
  ],
  "properties": {
    "schemaVersion": {
      "const": 1
    },
    "registryVersion": {
      "type": "string",
      "minLength": 1
    },
    "engine": {
      "type": "object",
      "required": [
        "id",
        "featureFlag",
        "delivery",
        "timing",
        "limits"
      ],
      "properties": {
        "id": {
          "const": "experience-engine-v2"
        },
        "featureFlag": {
          "const": "engine_v2_active"
        },
        "delivery": {
          "type": "object",
          "required": [
            "publicPath",
            "cacheControl",
            "fallbackMode",
            "rejectUnknownSchemaVersion"
          ],
          "properties": {
            "publicPath": {
              "type": "string",
              "minLength": 1
            },
            "cacheControl": {
              "type": "string",
              "minLength": 1
            },
            "bundledFallbackRequired": {
              "type": "boolean"
            },
            "fallbackMode": {
              "const": "DISABLE_REWARDS_AND_HOLD_EVENTS"
            },
            "rejectUnknownSchemaVersion": {
              "const": true
            }
          },
          "additionalProperties": false
        },
        "timing": {
          "type": "object",
          "required": [
            "collectionWindowMs",
            "reactivationDelayMs",
            "overlayTransitionMs",
            "effectDurationMs",
            "experienceLockMs",
            "feedbackSequenceDelayMs",
            "claimLeaseMs"
          ],
          "properties": {
            "collectionWindowMs": {
              "const": 3000
            },
            "reactivationDelayMs": {
              "const": 5000
            },
            "overlayTransitionMs": {
              "type": "integer",
              "minimum": 0
            },
            "effectDurationMs": {
              "type": "integer",
              "minimum": 0
            },
            "experienceLockMs": {
              "const": 10000
            },
            "feedbackSequenceDelayMs": {
              "const": 1500
            },
            "claimLeaseMs": {
              "type": "integer",
              "minimum": 1000
            }
          },
          "additionalProperties": false
        },
        "limits": {
          "type": "object",
          "required": [
            "maxPendingCelebrations",
            "maxConsolidatedItems",
            "maxEventAgeDays"
          ],
          "properties": {
            "maxPendingCelebrations": {
              "type": "integer",
              "minimum": 1,
              "maximum": 500
            },
            "maxConsolidatedItems": {
              "type": "integer",
              "minimum": 1,
              "maximum": 100
            },
            "maxEventAgeDays": {
              "type": "integer",
              "minimum": 1
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "firestore": {
      "type": "object",
      "required": [
        "maintenanceConfig",
        "gamificationProfile",
        "pendingCelebrations",
        "personalWallet",
        "workspaceWallet",
        "userActivityEvent",
        "workspaceActivityEvent",
        "rewardLedgerEntry",
        "feedbackDraft",
        "feedbackHistory"
      ],
      "properties": {
        "maintenanceConfig": {
          "type": "string",
          "minLength": 1
        },
        "gamificationProfile": {
          "type": "string",
          "minLength": 1
        },
        "pendingCelebrations": {
          "type": "string",
          "minLength": 1
        },
        "personalWallet": {
          "type": "string",
          "minLength": 1
        },
        "workspaceWallet": {
          "type": "string",
          "minLength": 1
        },
        "userActivityEvent": {
          "type": "string",
          "minLength": 1
        },
        "workspaceActivityEvent": {
          "type": "string",
          "minLength": 1
        },
        "rewardLedgerEntry": {
          "type": "string",
          "minLength": 1
        },
        "feedbackDraft": {
          "type": "string",
          "minLength": 1
        },
        "feedbackHistory": {
          "type": "string",
          "minLength": 1
        }
      },
      "additionalProperties": false
    },
    "processing": {
      "type": "object",
      "required": [
        "authority",
        "deduplicationKey",
        "timestampAuthority",
        "rewardAndAuditAtomic",
        "pendingCelebrationsSourceOfTruth",
        "singlePresenterStrategy",
        "acknowledgeAfterEffect",
        "eventsDuringReveal"
      ],
      "additionalProperties": true
    },
    "conditionLanguage": {
      "type": "object",
      "required": [
        "version",
        "operators",
        "resetFrequencies"
      ],
      "additionalProperties": true
    },
    "performance": {
      "type": "object",
      "required": [
        "selection",
        "tiers"
      ],
      "properties": {
        "selection": {
          "type": "object",
          "additionalProperties": {
            "anyOf": [
              {
                "type": "boolean"
              },
              {
                "type": "number"
              }
            ]
          }
        },
        "tiers": {
          "type": "object",
          "required": [
            "HIGH",
            "LOW",
            "REDUCED_MOTION"
          ],
          "properties": {
            "HIGH": {
              "$ref": "#/definitions/performanceTier"
            },
            "LOW": {
              "$ref": "#/definitions/performanceTier"
            },
            "REDUCED_MOTION": {
              "$ref": "#/definitions/performanceTier"
            }
          },
          "additionalProperties": false
        }
      },
      "additionalProperties": false
    },
    "feedback": {
      "type": "object",
      "required": [
        "trigger",
        "presentation",
        "forms"
      ],
      "properties": {
        "trigger": {
          "type": "object",
          "required": [
            "globalActionCount",
            "elapsedDays",
            "selectionStrategy",
            "resetOn",
            "preserveOnOverlaySkip"
          ],
          "additionalProperties": true
        },
        "presentation": {
          "type": "object",
          "required": [
            "maxQuestionsPerForm",
            "ratingMin",
            "ratingMax",
            "remarkRequired",
            "remarkMaxLength",
            "allowQuestionSkip"
          ],
          "additionalProperties": true
        },
        "forms": {
          "type": "object",
          "minProperties": 1,
          "additionalProperties": {
            "type": "object",
            "required": [
              "id",
              "category",
              "question",
              "reward"
            ],
            "properties": {
              "id": {
                "type": "string",
                "pattern": "^FORM_[A-Z0-9_]+$"
              },
              "category": {
                "enum": [
                  "TASK",
                  "AI",
                  "FALLBACK"
                ]
              },
              "question": {
                "type": "string",
                "minLength": 1
              },
              "reward": {
                "type": "object",
                "required": [
                  "credits",
                  "wallet"
                ],
                "properties": {
                  "credits": {
                    "type": "integer",
                    "minimum": 0
                  },
                  "wallet": {
                    "const": "PERSONAL"
                  }
                },
                "additionalProperties": false
              }
            },
            "additionalProperties": false
          }
        }
      },
      "additionalProperties": false
    },
    "celebrationCatalog": {
      "type": "object",
      "minProperties": 1,
      "additionalProperties": {
        "type": "object",
        "required": [
          "effectId",
          "aggregate",
          "performanceTier",
          "overlay"
        ],
        "additionalProperties": true
      }
    },
    "gamification": {
      "type": "object",
      "required": [
        "xp",
        "dailyActivityCreditCap",
        "activityTierTicketRewards",
        "login",
        "spins",
        "unlocks",
        "raid"
      ],
      "additionalProperties": true
    },
    "actions": {
      "type": "object",
      "minProperties": 1,
      "additionalProperties": {
        "type": "object",
        "required": [
          "scope",
          "gamification",
          "celebration",
          "condition"
        ],
        "properties": {
          "scope": {
            "enum": [
              "USER",
              "WORKSPACE"
            ]
          },
          "gamification": {
            "type": "array",
            "items": {
              "type": "object",
              "required": [
                "type"
              ],
              "additionalProperties": true
            }
          },
          "celebration": {
            "type": "object",
            "required": [
              "effect",
              "messageKey"
            ],
            "properties": {
              "effect": {
                "type": "string",
                "minLength": 1
              },
              "messageKey": {
                "anyOf": [
                  {
                    "type": "string"
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            },
            "additionalProperties": false
          },
          "condition": {
            "type": "object",
            "required": [
              "operator",
              "resetFrequency"
            ],
            "additionalProperties": true
          },
          "track": {
            "type": "object",
            "additionalProperties": true
          }
        },
        "additionalProperties": false
      }
    },
    "guides": {
      "type": "array",
      "items": {
        "type": "object",
        "required": [
          "journeyId",
          "title",
          "description"
        ],
        "properties": {
          "journeyId": {
            "type": "string",
            "minLength": 1
          },
          "title": {
            "type": "string",
            "minLength": 1
          },
          "description": {
            "type": "string",
            "minLength": 1
          },
          "thumbnail": {
            "type": "string"
          },
          "category": {
            "enum": [
              "ONBOARDING",
              "FEATURE",
              "STORY"
            ]
          }
        },
        "additionalProperties": false
      }
    }
  },
  "definitions": {
    "performanceTier": {
      "type": "object",
      "required": [
        "renderer",
        "particleCount",
        "durationMs"
      ],
      "properties": {
        "renderer": {
          "enum": [
            "CANVAS_CONFETTI",
            "CSS_BURST",
            "STATIC_HIGHLIGHT"
          ]
        },
        "particleCount": {
          "type": "integer",
          "minimum": 0
        },
        "durationMs": {
          "type": "integer",
          "minimum": 0
        },
        "spread": {
          "type": "number"
        },
        "gravity": {
          "type": "number"
        },
        "decay": {
          "type": "number"
        }
      },
      "additionalProperties": false
    }
  }
} as const
